// extracted by mini-css-extract-plugin
export default {"countryImg":"country-flag_countryImg__bWPlp"};